import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/shoplist',
    name: 'shoplist',
    component: () => import('../views/ShopList.vue')
  },
  {
    path: '/shopbuy',
    name: 'shopbuy',
    component: () => import('../views/ShopBuy.vue')
  },
  {
    path: '/shoppingmoney',
    name: 'shoppingmoney',
    component: () => import('../views/ShoppingMoney.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
